import { cn } from "@gerama/utils";

const DELAYS = ["-0.9s", "-0.3s", "-0.6s", "-0.15s"];

/**
 * Small bouncing equalizer laid over the artwork of whatever is playing in a
 * list. Frozen (but still shown) while paused; still under reduced motion.
 */
export function NowPlayingBars({ playing, className }: { playing: boolean; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 flex items-center justify-center gap-[2px] bg-black/50",
        className,
      )}
    >
      {DELAYS.map((delay) => (
        <span
          key={delay}
          className="now-playing-bar bg-primary h-1/2 w-[3px] origin-bottom rounded-full"
          style={{
            animationDelay: delay,
            animationPlayState: playing ? "running" : "paused",
          }}
        />
      ))}
    </span>
  );
}
